"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dropdown = require("../../../../styles/2_commonComponentStyles/dropdown");

var _AnnotatedSuggestionRow = require("./AnnotatedSuggestionRow.styles");

var _propTypes2 = _interopRequireDefault(require("../../../../constants/propTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
// ours
// Resources

/**
 * As an extension of the DropdownButton, this could technically support left and right icons, but the props are not currently being passed through.
 */
var AnnotatedSuggestionRow = function AnnotatedSuggestionRow(_ref) {
  var active = _ref.active,
      attribution = _ref.attribution,
      className = _ref.className,
      colorTheme = _ref.colorTheme,
      dataTestId = _ref.dataTestId,
      onClick = _ref.onClick,
      suggestion = _ref.suggestion;
  return /*#__PURE__*/_react.default.createElement(_AnnotatedSuggestionRow.StyledDropdownButton, {
    isActive: active,
    isAttribution: !!attribution,
    className: className,
    colorTheme: colorTheme,
    dataTestId: dataTestId,
    onClick: attribution ? function (e) {
      e.preventDefault();
    } : function () {
      onClick(suggestion);
    }
  }, attribution ? /*#__PURE__*/_react.default.createElement(_AnnotatedSuggestionRow.Attribution, {
    colorTheme: colorTheme
  }, attribution()) : /*#__PURE__*/_react.default.createElement(_AnnotatedSuggestionRow.ContentWrapper, null, /*#__PURE__*/_react.default.createElement(_AnnotatedSuggestionRow.LeftContent, null, suggestion.primaryText), suggestion.secondaryText ? /*#__PURE__*/_react.default.createElement(_AnnotatedSuggestionRow.RightContent, null, suggestion.secondaryText) : null));
};

AnnotatedSuggestionRow.propTypes = {
  active: _propTypes.default.bool,
  attribution: _propTypes.default.func,
  className: _propTypes.default.string,
  colorTheme: _propTypes.default.oneOf(_dropdown.dropdownColorThemes),
  dataTestId: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired,
  suggestion: _propTypes.default.shape({
    primaryText: _propTypes2.default.children.isRequired,
    secondaryText: _propTypes2.default.children,
    selectionId: _propTypes.default.string
  }).isRequired
};
AnnotatedSuggestionRow.defaultProps = {
  active: false,
  attribution: undefined,
  className: '',
  colorTheme: 'primary'
};
var _default = AnnotatedSuggestionRow;
exports.default = _default;